import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import { initState } from './reducers';
import AuthHttpService from '../../services/auth.http';
import UserHttpService from '../../services/user.http';
import ConnectionHttpService from '../../services/connection.http';
import { historyPush } from '../../common/history';

export function* START_PHONE_VERIFICATION({ payload }) {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  const response = yield call(AuthHttpService.startVerification, payload);
  if (response?.status < 400) {
    yield put({
      type: actions.user.SET_STATE,
      payload: {
        phone: payload.phone,
        SignUpStep: 1,
        ResetPasswordStep: 1
      }
    });

    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'success',
        message: 'We sent the verification code to your phone number'
      }
    });
  } else {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'error',
        message: response?.data.message
      }
    });
  }

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export function* CHECK_PHONE_VERIFICATION({ payload }) {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  const response = yield call(AuthHttpService.checkVerification, payload);
  if (response?.status < 400) {
    yield put({
      type: actions.user.SET_STATE,
      payload: {
        phone: payload.phone,
        SignUpStep: 2,
        ResetPasswordStep: 2
      }
    });

    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'success',
        message: 'Verified your phone number'
      }
    });
  } else {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'error',
        message: response?.data.message
      }
    });
  }

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export function* SET_PASSWORD({ payload }) {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  const response = yield call(AuthHttpService.setPassword, payload);
  if (response?.status < 400) {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'success',
        message: 'Your password has been set successfully'
      }
    });

    historyPush('/login');
  } else {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'error',
        message: response?.data.message
      }
    });
  }

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export function* REGISTER({ payload }) {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  const response = yield call(AuthHttpService.register, payload);
  if (response?.status < 400) {
    yield localStorage.setItem('personal-account.token', response.data.token);

    const event_uid = localStorage.getItem('user.marketplace.uid');
    const connResponse = yield call(ConnectionHttpService.join, event_uid);
    if (!connResponse || connResponse.state >= 400) {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: connResponse?.data?.message || 'Event Connection Error!'
        }
      });

      yield put({
        type: actions.user.SET_STATE,
        payload: {
          loading: false
        }
      });

      return;
    }

    yield put({
      type: actions.user.SET_STATE,
      payload: {
        authorized: true,
        ...response.data.user
      }
    });

    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'success',
        message: 'Signed up successfully'
      }
    });

    yield historyPush('/products');
  } else {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'error',
        message: response?.data.message
      }
    });
  }

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export function* LOGIN({ payload }) {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  const response = yield call(AuthHttpService.login, payload);
  if (response?.status < 400) {
    yield localStorage.setItem('personal-account.token', response.data.token);

    const event_uid = localStorage.getItem('user.marketplace.uid');
    const connResponse = yield call(ConnectionHttpService.join, event_uid);
    if (!connResponse || connResponse.state >= 400) {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: connResponse?.data?.message || 'Event Connection Error!'
        }
      });

      yield put({
        type: actions.user.SET_STATE,
        payload: {
          loading: false
        }
      });

      return;
    }

    yield historyPush('/products');

    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'success',
        message: 'Logged in successfully'
      }
    });
  } else {
    yield put({
      type: actions.notification.SET_STATE,
      payload: {
        open: true,
        severity: 'error',
        message: response?.data.message
      }
    });
  }

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export function* LOGOUT() {
  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: true
    }
  });

  yield call(AuthHttpService.logout);
  yield localStorage.removeItem('personal-account.token');

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      ...initState,
      authorized: false
    }
  });

  yield historyPush('/login');

  yield put({
    type: actions.user.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.user.GET_CURRENT_ACCOUNT),
    takeEvery(actions.user.START_PHONE_VERIFICATION, START_PHONE_VERIFICATION),
    takeEvery(actions.user.CHECK_PHONE_VERIFICATION, CHECK_PHONE_VERIFICATION),
    takeEvery(actions.user.SET_PASSWORD, SET_PASSWORD),
    takeEvery(actions.user.REGISTER, REGISTER),
    takeEvery(actions.user.LOGIN, LOGIN),
    takeEvery(actions.user.LOGOUT, LOGOUT),
  ]);
}
